(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uj-motion-layer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const home = document.querySelector('.uj-noir');
    const layer = document.querySelector('.uj-motion-layer');

    if (!home || !layer || home.dataset.ujMotionReady === 'true') return;

    home.dataset.ujMotionReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const progress = layer.querySelector('.uj-motion-progress');
    const pageWrapper = document.querySelector('.page-wrapper');
    const filmStage = home.querySelector('.uj-film__stage');
    const filmVideo = filmStage?.querySelector('.uj-film__video');
    const filmToggle = filmStage?.querySelector('.uj-film__toggle');
    const filmTimeline = [...home.querySelectorAll('.uj-film__timeline span')];
    const editorialMedia = home.querySelector('.uj-editorial__media');

    if (reducedMotion) {
      filmVideo?.pause();
      home.classList.add('uj-motion-ready');
      return;
    }

    const selector = [
      '.uj-intro',
      '.uj-block__head',
      '.uj-card',
      '.uj-category-head',
      '.uj-cat',
      '.uj-film__stage',
      '.uj-film__copy',
      '.uj-editorial__copy',
      '.uj-editorial__media',
      '.uj-trust > a',
      '.uj-trust > div'
    ].join(',');
    const revealItems = [...home.querySelectorAll(selector)];
    const viewportLimit = window.innerHeight * .94;

    revealItems.forEach((item) => {
      const siblings = item.parentElement ? [...item.parentElement.children] : [];
      const siblingIndex = Math.max(0, siblings.indexOf(item));
      const delay = Math.min(siblingIndex % 6, 5) * 55;

      item.classList.add('uj-motion-reveal');
      item.style.setProperty('--uj-motion-delay', `${delay}ms`);

      if (item.getBoundingClientRect().top < viewportLimit) {
        item.classList.add('is-inview');
      }
    });

    home.classList.add('uj-motion-ready');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: .08
    });

    revealItems.forEach((item) => {
      if (!item.classList.contains('is-inview')) observer.observe(item);
    });

    if (filmVideo && filmStage && filmToggle) {
      let userPaused = false;

      const setFilmControl = (isPaused) => {
        filmToggle.setAttribute('aria-label', isPaused ? filmToggle.dataset.playLabel : filmToggle.dataset.pauseLabel);
        const icon = filmToggle.querySelector('span');
        if (icon) icon.textContent = isPaused ? '▶' : 'Ⅱ';
      };

      const updateFilmTimeline = () => {
        if (!filmVideo.duration) return;
        const progressRatio = Math.min(1, Math.max(0, filmVideo.currentTime / filmVideo.duration));
        filmTimeline.forEach((segment, index) => {
          segment.style.setProperty('--uj-film-fill', Math.min(1, Math.max(0, progressRatio * 3 - index)));
        });
      };

      const playFilm = () => {
        if (userPaused) return;
        filmVideo.play().then(() => setFilmControl(false)).catch(() => setFilmControl(true));
      };

      filmVideo.muted = true;
      filmVideo.addEventListener('timeupdate', updateFilmTimeline);
      filmVideo.addEventListener('play', () => setFilmControl(false));
      filmVideo.addEventListener('pause', () => setFilmControl(true));
      filmVideo.addEventListener('error', () => filmStage.classList.add('is-video-fallback'), { once: true });

      filmToggle.addEventListener('click', () => {
        if (filmVideo.paused) {
          userPaused = false;
          playFilm();
          return;
        }

        userPaused = true;
        filmVideo.pause();
      });

      const filmObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playFilm();
          } else {
            filmVideo.pause();
          }
        });
      }, { threshold: .22 });

      filmObserver.observe(filmStage);
      setFilmControl(filmVideo.paused);
    }

    let ticking = false;

    const updateMotion = () => {
      const usesPageWrapper = window.innerWidth >= 990 && pageWrapper;
      const scroller = usesPageWrapper ? pageWrapper : document.scrollingElement;
      const scrollTop = usesPageWrapper ? pageWrapper.scrollTop : window.scrollY;
      const scrollRange = Math.max(1, scroller.scrollHeight - scroller.clientHeight);
      const ratio = Math.min(1, Math.max(0, scrollTop / scrollRange));

      progress.style.transform = `scaleX(${ratio})`;

      if (window.innerWidth >= 750) {
        const heroShift = Math.min(32, Math.max(0, scrollTop * .055));
        home.style.setProperty('--uj-hero-shift', `${heroShift}px`);

        const setDepth = (element, property, distance) => {
          if (!element) return;
          const rect = element.getBoundingClientRect();
          const travel = window.innerHeight + rect.height;
          const visibleRatio = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / travel));
          home.style.setProperty(property, `${(visibleRatio - .5) * distance}px`);
        };

        setDepth(filmStage, '--uj-film-shift', 22);
        setDepth(editorialMedia, '--uj-editorial-shift', 18);
      }

      ticking = false;
    };

    const requestMotionUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateMotion);
    };

    updateMotion();
    window.addEventListener('scroll', requestMotionUpdate, { passive: true });
    pageWrapper?.addEventListener('scroll', requestMotionUpdate, { passive: true });
    window.addEventListener('resize', requestMotionUpdate, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
